export function convertNullToEmptyText(value: string | null): string {
  return value || '';
}
